const JobCard = ({ iconClass, title, href, positions, icon }) => (
  <div className="browse-jobs-card">
    <div className="icon">
      {icon ? <img src={icon} alt={title} /> : <i className={iconClass}></i>}
    </div>
    <h3 style={{ color: "white" }}>{title}</h3>
    <p>({positions} open positions)</p>
    <a href={href} className="more-btn">
      <i className="ri-arrow-right-s-line"></i>
    </a>
  </div>
);

export default JobCard;
